"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tn = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "-60 -40 120 80", ...props },
    react_1.default.createElement("g", { fill: "#E70013" },
        react_1.default.createElement("path", { d: "M-60-40H60v80H-60z" }),
        react_1.default.createElement("circle", { r: 20, fill: "#FFF" }),
        react_1.default.createElement("circle", { r: 15 }),
        react_1.default.createElement("circle", { cx: 4, r: 12, fill: "#FFF" }),
        react_1.default.createElement("path", { d: "m-5 0 16.281-5.29L1.22 8.56V-8.56L11.28 5.29z" }))));
exports.default = Tn;
//# sourceMappingURL=Tn.js.map